// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import CountingBundleEarlierOrderTable from './components/counting-bundle-earlier-order-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getCountingBundleEarlierOrder from './repositories';
import { getFamilies } from '../../common/repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class CountingBundleEarlierOrder extends Component {

    state = {
        families: [],
        selectedFamily: '',
        results: null
    };

    componentDidMount = () => {

        getFamilies( ).then( response => {

            this.props.increaseCounter();
            this.setState( {
                families: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamily: val,
            results: null
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamily !== '-1' ) {

            this.props.increaseCounter();
            getCountingBundleEarlierOrder( this.state.selectedFamily )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedFamily, families, results
        } = this.state;

        const finalCountingBundleOrderResults = results !== null && results.resultsList !== null ?
            results.resultsList.map( i => (
                {
                    ...i,
                    ...{ unitName: this.props.unit.name },
                    ...{ reportType: results.reportType }
                } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Counting Bundle Earlier than Order</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-counting-bundle-earlier-than-order-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-counting-bundle-order-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={families}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamily}
                                />
                                {selectedFamily && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        { results !== null && results.resultsList.length === 0 && (
                            <div className="errorMessage">There are no orders with code build weeks later than the order build week for family {selectedFamily} </div>
                        )}
                        { results !== null && results.resultsList.length > 0 && (
                            <CountingBundleEarlierOrderTable
                                results={finalCountingBundleOrderResults}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CountingBundleEarlierOrder.displayName = 'CheckOrdersOrderDetail';
CountingBundleEarlierOrder.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( CountingBundleEarlierOrder ) );
